import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { AppButton } from "@/components/ui";

/**
 * 404 Not Found page.
 * All strings externalized via i18n.
 */
export function NotFoundPage(): React.ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-foreground-muted">{t("notFound.code")}</h1>
        <h2 className="text-xl font-semibold text-foreground">{t("notFound.title")}</h2>
        <p className="text-foreground-secondary">{t("notFound.message")}</p>
        <div className="mt-4">
          <AppButton variant="ghost" onPress={() => void navigate("/")}>
            {t("notFound.goHome")}
          </AppButton>
        </div>
      </div>
    </div>
  );
}
